import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../Card';
import './CampaignPerformanceTable.css';

export default function CampaignPerformanceTable({ campaigns, loading }) {
  if (loading) {
    return (
      <Card>
        <h2 className="card-title">Campaign Performance</h2>
        <div style={{ padding: 'var(--spacing-lg)', textAlign: 'center', color: 'var(--text-secondary)' }}>
          Loading campaign data...
        </div>
      </Card>
    );
  }

  if (!campaigns || campaigns.length === 0) {
    return (
      <Card>
        <h2 className="card-title">Campaign Performance</h2>
        <div style={{ padding: 'var(--spacing-lg)', textAlign: 'center', color: 'var(--text-secondary)' }}>
          No campaign data available yet.
        </div>
      </Card>
    );
  }

  return (
    <Card padding={false}>
      <div style={{ padding: 'var(--spacing-lg) var(--spacing-lg) 0' }}>
        <h2 className="card-title">Campaign Performance</h2>
      </div>
      <div className="campaign-performance-table">
        <table className="data-table">
          <thead>
            <tr>
              <th>Campaign</th>
              <th>Status</th>
              <th>Sent</th>
              <th>Replies</th>
              <th>Reply %</th>
              <th>Seen %</th>
              <th>Engaged %</th>
              <th>Booked</th>
            </tr>
          </thead>
          <tbody>
            {campaigns.map((campaign) => (
              <tr key={campaign.campaign_id}>
                <td>
                  <Link 
                    to={`/campaigns/${campaign.campaign_id}/steps`}
                    style={{ 
                      color: 'var(--primary)', 
                      textDecoration: 'none',
                      fontWeight: 'var(--font-weight-semibold)'
                    }}
                  >
                    {campaign.campaign_name}
                  </Link>
                </td>
                <td>
                  <span className={`status-badge ${campaign.campaign_active ? 'status-active' : 'status-inactive'}`}>
                    {campaign.campaign_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>{campaign.messages_sent}</td>
                <td>{campaign.replies}</td>
                <td>
                  <span className="performance-rate" style={{
                    color: campaign.reply_rate >= 5 ? 'var(--success)' : campaign.reply_rate >= 2 ? 'var(--warning)' : 'var(--text-secondary)'
                  }}>
                    {campaign.reply_rate}%
                  </span>
                </td>
                <td>
                  <span style={{ color: 'var(--text-secondary)' }}>
                    {campaign.seen_rate}%
                  </span>
                </td>
                <td>
                  <span style={{ color: 'var(--text-secondary)' }}>
                    {campaign.engagement_rate}%
                  </span>
                </td>
                <td>
                  <span style={{ 
                    fontWeight: campaign.leads_booked > 0 ? 'var(--font-weight-semibold)' : 'normal',
                    color: campaign.leads_booked > 0 ? 'var(--success)' : 'var(--text-secondary)'
                  }}>
                    {campaign.leads_booked}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
